/* eslint-disable */
import React, { useEffect } from "react";
import Header from "components/Common/Header/Header";
import LeadOpportunityKanbanBody from "components/CRMComponents/CRMLeadInformationComponents/CRMLeadOpportunity/LeadOpportunityKanban/LeadOpportunityKanbanBody";

const CrmLeadOpportunityKanban = () => {
  useEffect(() => {
    document.title = "CRM Lead Information | Opportunity";
  }, []);

  return (
    <main id="app">
      <Header moduleName="crm" />
      <LeadOpportunityKanbanBody />
    </main>
  );
};

export default CrmLeadOpportunityKanban;
